import React, { Component } from "react";

import ListQuestion from "./list_question";
import ListAnswers from "./list_answer";
import ListAnswerRow from "./list_answer_row";
import ListComment from "./list_comment";

import qs from "qs";

class ListQuestionAnswer extends Component {
  state = { row: false };

  componentDidUpdate() {
    const query = qs.parse(this.props.history.location.search, {
      ignoreQueryPrefix: true
    });

    if (query.close === "true" && this.state.row === true) {
      this.props.list_fullscreen();
      const row = !this.state.row;
      this.setState({ row });
    } else if (
      query.open === this.props.question.id.toString() &&
      this.state.row === false
    ) {
      this.props.list_fullscreen();
      const row = !this.state.row;
      this.setState({ row });
    }
  }
  render() {
    // Showing List Creator Answer

    var classQuestion =
      this.state.row === true
        ? "question_answer_v2 pb-3 question_answer_v2_full_screen"
        : "question_answer_v2 pb-3 pt-3";

    return (
      <div className={classQuestion}>
        {this.renderReturn()}
        <ListQuestion
          question={this.props.question}
          showAnswer={true}
          onClick={this.openQuestion}
          row={this.state.row}
          link={this.props.link}
        />

        {this.renderFullscreen()}
      </div>
    );
  }

  renderReturn() {
    if (this.state.row === true) {
      return (
        <nav className="navbar navigationBar">
          <div className="yaystack_icon cursor_btn" onClick={this.openQuestion}>
            <ion-icon name="ios-arrow-back" class="ion-icon" />
          </div>
        </nav>
      );
    }
  }

  renderFullscreen() {
    if (this.state.row === true) {
      var listCreatorAnswer = <div />;
      if (this.props.question.user_answers) {
        const self = this;
        listCreatorAnswer = this.props.question.user_answers.map(function(
          answer
        ) {
          return (
            <ListAnswerRow
              key={answer.id}
              answer={answer}
              row={true}
              removeAnswer={self.props.removeAnswer}
              updateAnswer={self.props.updateAnswer}
            />
          );
        });
      }
      return (
        <React.Fragment>
          {listCreatorAnswer}
          <ListAnswers
            question={this.props.question}
            row={this.state.row}
            removeAnswer={this.props.removeAnswer}
            updateAnswer={this.props.updateAnswer}
          />
          <ListComment
            question={this.props.question}
            addAnswer={this.props.addAnswer}
            user={this.props.user}
            list={this.props.list}
          />
        </React.Fragment>
      );
    } else {
      return (
        <div>
          <ListAnswers question={this.props.question} row={false} />
        </div>
      );
    }
  }

  openQuestion = event => {
    event.preventDefault();
    this.props.list_fullscreen();
    const row = !this.state.row;
    if (row === true) {
      this.props.history.push(`?open=${this.props.question.id}`);
    } else {
      this.props.history.push(`?close=${true}`);
    }
    this.setState({ row });
  };
}

export default ListQuestionAnswer;



// WEBPACK FOOTER //
// ./src/components/list/interface/list_question_answer.jsx